import moment from 'moment'

/**
 * Takes a moment date object and sets the time to midday exactly
 * @param {moment} date
 * @returns moment
 */
export const setDateToMidday = (date) => date.hour(12).minute(0).second(0).millisecond(0)

/**
 * Takes a start date and an end date and tests if the end date is before or equal to the start date.
 * NOTE! - ONLY CHECKS FOR MONTH DAY AND YEAR, NOT HOUR MINUTE SECOND
 * @param {object} props
 * @param {moment} props.startDate
 * @param {moment} props.endDate
 * @returns boolean
 */
export const endDateIsBeforeOrEqualToStartDate = ({ startDate, endDate }) => {
	if (!startDate || (startDate && !endDate)) {
		return false
	}

	const _startDate = setDateToMidday(startDate)
	const _endDate = setDateToMidday(endDate)

	return _startDate.diff(_endDate) >= 0
}

/**
 * Takes a moment object or a Date object and returns the iso string
 * @param {moment | Date} date
 * @returns string
 */
export const convertDateToISOString = (date) => date.toISOString()

/**
 * Takes a date string, converts to a moment instance then returns a JS Date object
 * @param {string} dateString
 * @returns Date
 */
export const convertDateStringToDate = (dateString) => moment(dateString).toDate()

/**
 *
 * @param {string} startDate - will be converted to a moment instance
 * @param {string} endDate - will be converted to a moment instance
 * @param {boolean | true} inclusive - Include the start and end dates in the output, defaults to true
 * @returns [string] - An array of date strings in the format MM-DD-YYYY
 */
export const getDaysBetweenDates = (startDate, endDate, inclusive = true, format = 'YYYY-MM-DD') => {
	let now = moment(startDate).clone()
	let end = moment(endDate).clone()

	if (!inclusive) {
		now = now.add(1, 'days')
		end = end.subtract(1, 'days')
	}
	const dates = []

	while (now.isSameOrBefore(end)) {
		dates.push(now.format(format))
		now.add(1, 'days')
	}

	return dates
}

/**
 * To be used when you need to create a visit without knowing the dates before hand.
 */
export const PLACEHOLDER_DATE = moment().year(2099).month(11).date(15).format('YYYY-MM-DD')

/**
 *
 * @param {*} date
 * @returns start of date in utc format, e.g. 2023-12-03T00:00:00.000+00:00
 */
export const standardizeStartOfDateUTC = (date) => moment(date).utc().startOf('day')

/**
 *
 * @param {*} date
 * @returns end of date in utc format, e.g. 2023-12-10T23:59:59.999+00:00
 */
export const standardizeEndOfDateUTC = (date) => moment(date).utc().endOf('day')

export const convert24HourTimeTo12HourTime = (time) => {
	if (!time) {
		return ''
	}
	const [hours, minutes] = time.split(':')
	const hour = parseInt(hours, 10)
	let minute = parseInt(minutes, 10)
	if (minute < 10) {
		minute = `0${minute}`
	}
	const isPM = hour >= 12
	const ampm = isPM ? 'PM' : 'AM'
	const displayHour = hour % 12 || 12
	return `${displayHour}:${minute} ${ampm}`
}
